import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  NgModule,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ClientRendererComponentModule } from '../renderers/client-renderer/client-renderer.component';
import {
  AutoScrollToDirectiveModule,
  RouterStaticLinkDirectiveModule,
  trackByProp,
} from '@icilalune/utils';
import { ForModule } from '@rx-angular/template';
import { NgArrayPipesModule } from 'ngx-pipes';
import { Client } from '@nx-icilalune/data/icilalune/types';

@Component({
  selector: 'i2l-ui-client-list',
  template: `
    <ng-container *ngIf="clients">
      <ul class="client-list">
        <li
          [i2lAutoScrollTo]="selectedId === client.id"
          [direction]="'y'"
          [windowMode]="true"
          [class.sticky]="client.sticky"
          *rxFor="
            let client of clients | truthify;
            index as idx;
            trackBy: trackByClientId
          "
        >
          <a [routerStaticLink]="client.path" [attr.title]="client.title">
            <i2l-ui-client-renderer
              [off]="!!selectedId && selectedId !== client.id"
              [active]="selectedId === client.id"
              [data]="client"
            ></i2l-ui-client-renderer>
          </a>
        </li>
      </ul>
    </ng-container>
  `,
  styleUrls: ['./client-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientListComponent implements OnChanges {
  @Input()
  clients: Client[] | undefined;

  @Input()
  columnCount!: number;

  @Input()
  itemsAspectRatio!: string;

  @Input()
  selectedId!: string | undefined;

  trackByClientId = trackByProp<Client>('id');

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { nativeElement } = this.el;
    if (!isNaN(changes['columnCount']?.currentValue)) {
      nativeElement.style.setProperty(
        '--column-count',
        this.columnCount.toString()
      );
    }
    if (changes['itemsAspectRatio']?.currentValue) {
      nativeElement.style.setProperty(
        '--grid-item-aspect-ratio',
        this.itemsAspectRatio
      );
    }
  }

  identity(index: number, item: Client) {
    return item?.id;
  }
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ClientRendererComponentModule,
    ForModule,
    RouterStaticLinkDirectiveModule,
    NgArrayPipesModule,
    AutoScrollToDirectiveModule,
  ],
  declarations: [ClientListComponent],
  exports: [ClientListComponent],
})
export class ClientListComponentModule {}
